import * as types from "./updateNotificationTypes";

export const showUpdateNotification = () => dispatch => {
  dispatch({ type: types.SHOW_UPDATE_NOTIFICATION_SUCCESS });
};

export const hideUpdateNotification = () => dispatch => {
  dispatch({ type: types.HIDE_UPDATE_NOTIFICATION_SUCCESS });
};
